import React from 'react';
import t from 'prop-types';

var EntradaTipoCategoria = function EntradaTipoCategoria(_ref) {
  var numUnidad = _ref.numUnidad,
      titulo = _ref.titulo;
  return React.createElement('div', {
    className: 'unidadIndice' + numUnidad + ' categoria'
  }, React.createElement('div', {
    className: 'bullet'
  }), React.createElement('span', {
    dangerouslySetInnerHTML: {
      __html: titulo
    }
  }));
};

EntradaTipoCategoria.propTypes = process.env.NODE_ENV !== "production" ? {
  numUnidad: t.string,
  titulo: t.string
} : {};
export default EntradaTipoCategoria;